/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function (window) {
  /* console.log('BEKBEK'); */
  $(document).ready(init);

  var sizeCarousels = [];
  var currentSizeGalleryIndex = 0;
  var $commercialArticleCarousels = $(
    ".Product .Product__Wrapper .commercial-article-galleries .carousel"
  );
  var currentSlideIndex = 0;
  var imgObservers;
  var scrollTimeout = 0;
  var needStateReplaceForPromotions = false;

  function init() {
    /* console.log('navigator.userAgent', navigator.userAgent); */

    if (window.urlParam("o") === "1") {
      // $('.ColorSwatchList .HorizontalList__Item:not(.color-with-discount)').hide();
      // $('.commercial-article-galleries .Product__SlideItem:not(.slide-with-discount)').attr('style', 'display:none !important');
      $(
        ".ColorSwatchList .HorizontalList__Item:not(.color-with-discount)"
      ).remove();
      $(
        ".commercial-article-galleries .Product__SlideItem:not(.slide-with-discount)"
      ).remove();
    }

    var $SizeSelect = $("select[id^='product-select-']");
    var $descWrapper = $(".ProductMeta .ProductMeta__Description .Rte-wrapper");

    if ($descWrapper && $descWrapper.length) {
      if ($descWrapper.find(".Rte").outerHeight() <= 46) {
        $descWrapper.addClass("expanded");
      } else {
        $descWrapper.find(".Rte").one("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          $descWrapper.addClass("expanded");
        });
      }
    }

    // PRODUCT CAROUSELS
    $commercialArticleCarousels.each(function (i, el) {
      var $target = $(el);

      var flkty = new Flickity(el, {
        watchCSS: true,
        prevNextButtons: false,
        pageDots: false,
      });

      // var $carousel = $($target[0]).flickity({
      //   watchCSS: true,
      //   prevNextButtons: false,
      //   pageDots: false,
      // });

      var data = window.Flickity.data($target.get(0));

      // $carousel.on("select.flickity", function (event, index) {
      //   if ($target.find(".carousel-cell.is-selected").length) {
      //     updatePageBG(
      //       $target.find(".carousel-cell.is-selected").attr("data-hex")
      //     );
      //   }
      // });

      flkty.on("select", function (event, index) {
        if ($target.find(".carousel-cell.is-selected").length) {
          updatePageBG(
            $target.find(".carousel-cell.is-selected").attr("data-hex")
          );
        }
      });

      var currentColor = "";
      $target.find(".carousel-cell").each(function (ii, elem) {
        var $cell = $(elem);

        if ($cell.attr("data-color") != currentColor) {
          currentColor = $cell.attr("data-color");
          $cell.addClass("color-first-cell");

          if (
            $cell &&
            $cell.attr("data-hex") &&
            $cell.attr("data-hex").length &&
            chroma($cell.attr("data-hex")).luminance() <= 0.5
          ) {
            $cell.addClass("patch-text-luminance");
          }

          if (ii != 0) {
            $cell.prev().addClass("color-last-cell");
          }
        }

        $cell.css(
          "background-color",
          window.bgColorMixer($cell.attr("data-hex")).dark
        );
      });

      currentColor = null;

      // sizeCarousels[i] = {
      //   variantIDs: $target.attr("data-variants-id").split(","),
      //   $target: $target,
      //   $carousel: $carousel,
      //   data: data,
      // };

      sizeCarousels[i] = {
        variantIDs: $target.attr("data-variants-id").split(","),
        $target: $target,
        flkty: flkty,
        data: data,
      };
    });

    $(".ProductForm .ColorSwatch__Radio").each(function (i, el) {
      if ($(el) && $(el).attr("data-hex")) {
        if (chroma($(el).attr("data-hex")).luminance() >= 0.9) {
          $(el).siblings(".ColorSwatch").addClass("patch-luminance");
        }
      } else {
        console.log('%c' + 'MISSING DATA-HEX for ' + $(el).val(), 'color: white; background: red; font-size: 14px; padding: 5px;');
      }
    });

    updatePageBG(
      $(".ProductForm .ColorSwatch__Radio:checked").attr("data-hex")
    );

    $(".ProductForm").on("change", function (e) {
      var hex = $(e.target).attr("data-hex");

      // product unavailable
      /*if (!$('.carousel.current-size > .carousel-cell[data-hex="' + hex + '"]').length) {
        return;
      }*/

      if (history.replaceState) {
        setTimeout(function () {
          updateProductCarousel(
            //new URL(window.location.href).searchParams.get("variant")
            window.urlParam("variant")
          );
        }, 400);
      }
    });

    $(".Popover__ValueList > button").on("click", function (event) {
      var $t = $(event.delegateTarget);
      console.log("\nSIZE:", $t.data());
      $SizeSelect.trigger("change");
    });

    var debounceTimeout = 0;
    var variant = window.urlParam("variant"); // new URL(window.location.href).searchParams.get("variant");

    $(window).on("resize", function () {
      window.clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(function () {
        updateProductScrollWatcher();
        variant = window.urlParam("variant"); //new URL(window.location.href).searchParams.get("variant");
        variant ? variant : $SizeSelect.val();
        updateProductCarousel(
          window.urlParam("variant") //new URL(window.location.href).searchParams.get("variant")
        );
      }, 300);
    });

    variant = window.urlParam("variant"); //new URL(window.location.href).searchParams.get("variant");

    updateProductCarousel(variant ? variant : $SizeSelect.val());

    // color filter selection, in case of no variant in URL
    if (!variant) {
      var targetColor = $(
        ".commercial-article-galleries .carousel.current-size .carousel-cell:first-of-type"
      ).attr("data-color");
      $(
        '.Product__Info .ProductForm__Variants .ColorSwatchList .ColorSwatch[data-tooltip="' +
          targetColor +
          '"]'
      ).trigger("click");
    }
    // set variant images and selected filter visible in UI
    $(".Product__Wrapper").attr("variant-in-url", "true");

    $(".carousel-cell .zoom-button").on("click", function (event) {
      var pswpElement = document.querySelectorAll(".pswp")[0];

      // build items array
      var items = [];

      // define options (if needed)
      var options = {
        barsSize: {
          top: 0,
          bottom: "auto",
        },
        arrowKeys: false,
        closeEl: true,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: true,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        //showAnimationDuration: 0,
        //hideAnimationDuration: 0
      };

      var sources = $(event.delegateTarget).attr("data-zoom-src").split(", ");
      var s;
      var w;
      var item = {};
      for (var i = 0; i < sources.length; i++) {
        s = sources[i].split(" ");
        w = parseInt(s[1].replace("w", ""));
        item[w] = {
          src: s[0],
          w: w,
          h: w / 0.8, // 4/5 ratio
        };
      }

      items.push(item);

      // Initializes and opens PhotoSwipe
      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      $(".pswp .pswp__bg").css(
        "background-color",
        $("body").css("background-color")
      );

      // create variable that will store real size of viewport
      var realViewportWidth,
        useLargeImages = false,
        firstResize = true,
        imageSrcWillChange;

      // beforeResize event fires each time size of gallery viewport updates
      gallery.listen("beforeResize", function () {
        // gallery.viewportSize.x - width of PhotoSwipe viewport
        // gallery.viewportSize.y - height of PhotoSwipe viewport
        // window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
        //                          1 (regular display), 2 (@2x, retina) ...

        // calculate real pixels when size changes
        realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

        // Code below is needed if you want image to switch dynamically on window.resize

        // Find out if current images need to be changed
        if (useLargeImages && realViewportWidth < 1000) {
          useLargeImages = false;
          imageSrcWillChange = true;
        } else if (!useLargeImages && realViewportWidth >= 1000) {
          useLargeImages = true;
          imageSrcWillChange = true;
        }

        // Invalidate items only when source is changed and when it's not the first update
        if (imageSrcWillChange && !firstResize) {
          // invalidateCurrItems sets a flag on slides that are in DOM,
          // which will force update of content (image) on window.resize.
          gallery.invalidateCurrItems();
        }

        if (firstResize) {
          firstResize = false;
        }

        imageSrcWillChange = false;
      });

      // gettingData event fires each time PhotoSwipe retrieves image source & size
      gallery.listen("gettingData", function (index, item) {
        // Set image source & size based on real viewport width

        /*
          	Available formats:

              200
              400
              600
              700
              800
              900
              1000
              1200
              1400
              1600

            Common media queries:

              $phone:            "screen and (max-width: 640px)";
              $tablet:           "screen and (min-width: 641px) and (max-width: 1007px)";
              $tablet-and-up:    "screen and (min-width: 641px)";
              $pocket:           "screen and (max-width: 1007px)";
              $lap:              "screen and (min-width: 1008px) and (max-width: 1239px)";
              $lap-and-up:       "screen and (min-width: 1008px)";
              $desk:             "screen and (min-width: 1240px)";
              $widescreen:       "screen and (min-width: 1500px)";
          */

        if (window.matchMedia("(min-width: 1400px)").matches) {
          item.src = item["2000"].src;
          item.w = item["2000"].w;
          item.h = item["2000"].h;
        } else if (window.matchMedia("(min-width: 1008px)").matches) {
          item.src = item["1600"].src;
          item.w = item["1600"].w;
          item.h = item["1600"].h;
        } else {
          item.src = item["1200"].src;
          item.w = item["1200"].w;
          item.h = item["1200"].h;
        }

        // It doesn't really matter what will you do here,
        // as long as item.src, item.w and item.h have valid values.
        //
        // Just avoid http requests in this listener, as it fires quite often
      });

      var autoZoom = function () {
        /*var _x = gallery.viewportSize.x;
        var _y = gallery.viewportSize.y;
        gallery.zoomTo(1, { x: _x / 2, y: _y / 2 }, 0, false);
		gallery.applyZoomPan(1, _x / 2 - gallery.currItem.x / 2, _y / 2 - gallery.currItem.y / 2);*/
      };

      gallery.listen("afterChange", autoZoom);
      gallery.init();

      window.gallery = gallery;
    });

    if (
      $(
        ".Popover.OptionSelector .Popover__Content .Popover__ValueList .Popover__Value"
      ).length <= 1
    ) {
      $(
        ".ProductForm__Variants .ProductForm__Option .ProductForm__Item"
      ).addClass("disable-dropdown");
    }

    /*
    	Se non è la prima immagine scroll-to con delay
    */
    var $variantImages = sizeCarousels[currentSizeGalleryIndex].$target.find(
      '.carousel-cell[data-variant="' + variant + '"]'
    );
    if (window.matchMedia("(min-width: 1008px)").matches) {
      if ($variantImages.length && $variantImages.index() > 0) {
        var $targetCell = $($variantImages.get(0));
        sizeCarousels[currentSizeGalleryIndex].$target.css(
          "visibility",
          "hidden"
        );
        $("html, body")
          .stop()
          .delay(1000)
          .animate(
            {
              scrollTop:
                $targetCell.offset().top - $("#section-header").outerHeight(),
            },
            0,
            function () {
              sizeCarousels[currentSizeGalleryIndex].$target.css(
                "visibility",
                ""
              );
            }
          );
      }
    } else {
      // sizeCarousels[currentSizeGalleryIndex].$carousel.flickity("resize");
      sizeCarousels[currentSizeGalleryIndex].flkty.resize();
    }

    $(".Product__Info .ProductForm__Variants .ColorSwatchList .ColorSwatch").on(
      "click",
      function (event) {
        if (window.urlParam("o") == 1) {
          needStateReplaceForPromotions = true;
        }
        $('.ColorSwatch__Radio:checked').prop('checked', false);
      }
    );

    // Handle product video
    if ($(".product-video").length) {
      $(".Product__Info .product-video-banner-cta").click(function () {
        $(".product-video .Video__PlayButton").click();
        return false;
      });
    }
  }

  function variantExistsInVariants(variant, variants) {
    var exists = variants.filter(function (el) {
      return el === variant;
    });
    return exists.length ? exists : null;
  }

  function updateProductCarousel(variant) {
    console.log("---> Update Product Carousel for variant: " + variant);

    if (!window.urlParam("o") && needStateReplaceForPromotions == 1) {
      window.history.replaceState(null, null, window.location.href + "&o=1");
    }

    needStateReplaceForPromotions = false;

    $commercialArticleCarousels.removeClass("current-size");

    var existsInCurrent = variantExistsInVariants(
      variant,
      sizeCarousels[currentSizeGalleryIndex].variantIDs
    );

    if (!existsInCurrent) {
      for (var i = 0, len = sizeCarousels.length; i < len; i++) {
        if (variantExistsInVariants(variant, sizeCarousels[i].variantIDs)) {
          currentSizeGalleryIndex = i;
          break;
        }
      }
    }

    sizeCarousels[currentSizeGalleryIndex].$target.addClass("current-size");
    // sizeCarousels[currentSizeGalleryIndex].$carousel.flickity("resize");
    sizeCarousels[currentSizeGalleryIndex].flkty.resize();

    var $variantImages = sizeCarousels[currentSizeGalleryIndex].$target.find(
      '.carousel-cell[data-variant="' + variant + '"]'
    );

    if ($variantImages.length) {
      var $targetCell = $($variantImages.get(0));
      if (window.matchMedia("(min-width: 1008px)").matches) {
        if (!imgObservers || !existsInCurrent) {
          updateProductScrollWatcher();
        }
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop:
                $targetCell.offset().top - $("#section-header").outerHeight(),
            },
            0
          );
      } else {
        $("html, body").stop();
        disableProductScrollWatcher();
        sizeCarousels[currentSizeGalleryIndex].flkty.selectCell(
          $targetCell.index(),
          true,
          true
        );

        // sizeCarousels[currentSizeGalleryIndex].$carousel.flickity(
        //   "selectCell",
        //   $targetCell.index(),
        //   true,
        //   true
        // );
      }
    }
  }

  function disableProductScrollWatcher() {
    $(".is-in-viewport").removeClass("is-in-viewport");
    if (imgObservers) {
      for (var i = 0; i < imgObservers.length; i++) {
        imgObservers[i].observer.unobserve(imgObservers[i].target);
      }
    }
    imgObservers = [];
  }

  function updateProductScrollWatcher() {
    disableProductScrollWatcher();

    if (!window.matchMedia("(min-width: 1008px)").matches) {
      return;
    }

    if (window.IntersectionObserver != undefined) {
      $(".carousel.current-size > .carousel-cell").each(function (i, el) {
        var observer = new window.IntersectionObserver(
          function (entries, observer) {
            var e = entries[0];
            var o = observer;

            $(e.target).attr("intersection-ratio", e.intersectionRatio);

            if (e.isIntersecting) {
              $(e.target).addClass("is-in-viewport");
            } else {
              $(e.target).removeClass("is-in-viewport");
            }

            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(function () {
              intersectionObserverCallback(e, o);
            }, 60);
          },
          {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
          }
        );

        observer.observe(el);

        imgObservers.push({
          observer: observer,
          target: el,
        });
      });
    }

    function intersectionObserverCallback(entry, observer, r) {
      var slide = evaluateIntersectionRatio();

      if (!slide) {
        currentSlideIndex = null;
        updatePageBG();
        return;
      }

      if (slide.index != currentSlideIndex) {
        currentSlideIndex = slide.index;

        var hex = $(slide.el).attr("data-hex");

        if (!hex) {
          return;
        }

        updatePageBG(hex);
      }
    }

    function evaluateIntersectionRatio() {
      if (!$(".carousel.current-size > .carousel-cell.is-in-viewport").length) {
        return null;
      }

      var index = 0;
      var current = 0;
      var val;
      var $cells = $(".carousel.current-size > .carousel-cell");

      $cells.each(function (i, el) {
        val = parseFloat($(el).attr("intersection-ratio"));
        if (val > current) {
          current = val;
          index = i;
          el = el;
        }
      });
      return {
        index: index,
        el: $cells[index],
      };
    }
  }
})(window);
